import { RolodexDocumentEntry } from 'features/files/types'

/**
 * Best-effort filename (with extension) to save a document under when
 * downloading it, derived from the entry's names and the resolved blob path.
 */
export const getDocumentDownloadName = (
  document: Pick<
    RolodexDocumentEntry,
    'filename' | 'visible_name' | 'file_type'
  >,
  filePath?: string
): string => {
  const pathBasename = filePath?.split('/').pop()
  const rawName =
    document.visible_name || document.filename || pathBasename || 'file'

  const fileType =
    document.file_type && document.file_type !== 'unknown'
      ? document.file_type.toLowerCase()
      : undefined
  const pathExtension = pathBasename?.includes('.')
    ? pathBasename.split('.').pop()?.toLowerCase()
    : undefined
  const extension = fileType ?? pathExtension

  if (extension && !rawName.toLowerCase().endsWith(`.${extension}`)) {
    return `${rawName}.${extension}`
  }
  return rawName
}
